/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Lots_TitleInputs */

const vi_pkl_lots_title = /** @type {(inputs: Pkl_Lots_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách lô vật tư bao bì`)
};

/**

* @param {Pkl_Lots_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_lots_title = /** @type {((inputs?: Pkl_Lots_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Lots_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_lots_title(inputs)
});